import React from "react"
import styled from "styled-components"

import Flex from "../../../Flex"
import Facebook from "../../../../icons/svg/facebook.svg"
import Instagram from "../../../../icons/svg/instagram.svg"
import Twitter from "../../../../icons/svg/twitter.svg"

const NavbarLinkWrapper = styled(Flex)`
`
const SocialLink = styled.a`
  display: block;
  margin-right: 32px;
  :hover {
    transition: all ease 0.6s;
  }
  :focus {
    outline: none;
  }
  svg path {
    fill: var(--color-black);
  }
`
const SocialWrapper = styled(Flex)`
    ${SocialLink} {
        svg path {
            transition: all ease 0.4s;
            fill: ${props => props.opened ? 'var(--color-white)' : 'var(--color-black)'};
        }
        svg path:hover {
            fill: ${props => props.opened = '#ffa500'};
        }
    }
`

const NavSocial = ({ opened }) => {
    return (
        <NavbarLinkWrapper opened={opened}>
            <SocialWrapper justifyContent="space-between" alignItems="center">
                <SocialLink
                    href="https://www.facebook.com/georgeandthebear/"
                    target="__blank"
                    rel="noopener noreferrer"
                >
                    <Facebook width="32" height="32" />
                </SocialLink>
                <SocialLink
                    href="https://www.instagram.com/georgeandthebear/"
                    target="__blank"
                    rel="noopener noreferrer"
                >
                    <Instagram width="28" height="28" />
                </SocialLink>
                <SocialLink
                    href="https://twitter.com/george_and_bear"
                    target="__blank"
                    rel="noopener noreferrer"
                >
                    <Twitter width="32" height="32" />
                </SocialLink>
            </SocialWrapper>
        </NavbarLinkWrapper>
    )
}

export default NavSocial